"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCurrentPromoDiscountedPriceWithMonitoring = exports.selectCurrentPromoDiscountedPrice = exports.selectPromoWithMonitoringDiscountText = exports.selectPromoDiscountText = exports.selectAbsoluteDiscountWithMonitoring = exports.selectAbsoluteDiscount = exports.selectRelativeDiscountWithMonitoring = exports.selectRelativeDiscount = exports.selectCurrentPromoWithMonitoring = exports.selectCurrentPromotionWithMonitoring = exports.selectCurrentPromo = exports.selectCurrentPromotion = exports.selectPartnerBannerLoading = exports.selectPartnerBanner = exports.selectEvergreenPromoWithMonitoringDetails = exports.selectEvergreenPromoDetails = exports.selectEvergreenPromo = exports.selectPromotionByCode = exports.selectPromotions = void 0;
const findFirstJust_1 = __importDefault(require("@simplisafe/ewok/monet-utils/findFirstJust"));
const verifyMaybeObj_1 = __importDefault(require("@simplisafe/ewok/monet-utils/verifyMaybeObj"));
const chain_1 = require("@simplisafe/monda/chain");
const monet_1 = require("monet");
const discounts_1 = require("../commercetools/discounts");
const select_1 = require("../redux/select");
/**
 * Returns an Immutable Map with promo codes as keys
 * and promo details as values.
 */
const selectPromotions = (state) => state.get('promotions');
exports.selectPromotions = selectPromotions;
/**
 * Returns promotion details for a specific promo code.
 */
const selectPromotionByCode = (state) => (code) => {
    const promotions = (0, exports.selectPromotions)(state);
    const details = code.chain(c => monet_1.Maybe.fromUndefined(promotions.get(c)));
    return details.chain(verifyMaybeObj_1.default);
};
exports.selectPromotionByCode = selectPromotionByCode;
/**
 * Returns the evergreen promo code without interactive monitoring.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromo = (state) => {
    const { value, loading } = state.get('evergreenPromotion');
    const promotion = (0, verifyMaybeObj_1.default)(value).map(evergreen => ({
        ...evergreen,
        promoFlag: (0, verifyMaybeObj_1.default)(evergreen.promoFlag)
    }));
    return loading ? (0, monet_1.None)() : promotion;
};
exports.selectEvergreenPromo = selectEvergreenPromo;
/**
 * Returns the details for the current evergreen promo code without interactive monitoring.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromoDetails = (state) => {
    const code = (0, exports.selectEvergreenPromo)(state).chain((0, chain_1.chainProp)('promoCode'));
    return (0, exports.selectPromotionByCode)(state)(code).chain(verifyMaybeObj_1.default);
};
exports.selectEvergreenPromoDetails = selectEvergreenPromoDetails;
/**
 * Returns the details for the current evergreen promo code with interactive monitoring.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 */
const selectEvergreenPromoWithMonitoringDetails = (state) => {
    const code = (0, exports.selectEvergreenPromo)(state).chain((0, chain_1.chainProp)('promoCodeWithMonitoring'));
    return (0, exports.selectPromotionByCode)(state)(code);
};
exports.selectEvergreenPromoWithMonitoringDetails = selectEvergreenPromoWithMonitoringDetails;
const selectPartnerBanner = (state) => {
    const { value, loading } = state.get('partnerBanner');
    return loading ? (0, monet_1.None)() : (0, verifyMaybeObj_1.default)(value);
};
exports.selectPartnerBanner = selectPartnerBanner;
const selectPartnerBannerLoading = (state) => state.get('partnerBanner').loading;
exports.selectPartnerBannerLoading = selectPartnerBannerLoading;
/**
* Returns the Promo object of the current promotion.
*/
const selectCurrentPromotion = (state) => {
    const promoCode = (0, select_1.selectCurrentPromoCode)(state);
    const promotions = (0, exports.selectPromotions)(state);
    return promoCode.chain(code => monet_1.Maybe.fromUndefined(promotions.get(code)));
};
exports.selectCurrentPromotion = selectCurrentPromotion;
/**
 * Returns the current promotion details without a service plan.
 * If there is an active promo it returns those details,
 * otherwise it returns the evergreen promotion.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 *
 * Use selectCurrentPromotion instead (new implementation).
 *
 * This implementation is old, since it asks for evergreen or active states. The new implementation
 * access the state.currentPromotion instead.
 */
const selectCurrentPromo = (state) => {
    const activePromo = (0, select_1.selectActivePromo)(state);
    const evergreen = (0, exports.selectEvergreenPromoDetails)(state);
    return (0, findFirstJust_1.default)([activePromo, evergreen]);
};
exports.selectCurrentPromo = selectCurrentPromo;
/**
 * Returns the Promo object of the active promotion with monitoring.
 */
const selectCurrentPromotionWithMonitoring = (state) => {
    const promoCode = (0, select_1.selectCurrentPromoCodeWithMonitoring)(state);
    return (0, exports.selectPromotionByCode)(state)(promoCode);
};
exports.selectCurrentPromotionWithMonitoring = selectCurrentPromotionWithMonitoring;
/**
 * Returns the current promotion details with a service plan.
 * If there is an active promo it returns those details,
 * otherwise it returns the evergreen promotion.
 *
 * @deprecated This function will not be used once we no longer request both endpoints from the
 * frontend on a page load.
 *
 * Use selectCurrentPromotionWithMonitoring instead (new implementation).
 *
 * This implementation is old, since it asks for evergreen or active states. The new implementation
 * access the state.currentPromotion instead.
 */
const selectCurrentPromoWithMonitoring = (state) => {
    const activePromo = (0, select_1.selectActivePromoWithMonitoring)(state);
    const evergreen = (0, exports.selectEvergreenPromoWithMonitoringDetails)(state);
    return (0, findFirstJust_1.default)([activePromo, evergreen]);
};
exports.selectCurrentPromoWithMonitoring = selectCurrentPromoWithMonitoring;
/**
* Returns the number (the percentage off) for the current relative discount.
* Uses the active promo if available, otherwise falls back to evergreen.
*/
const selectRelativeDiscount = (state) => (0, exports.selectCurrentPromotion)(state)
    .chain((0, chain_1.chainProp)('relativeDiscount'));
exports.selectRelativeDiscount = selectRelativeDiscount;
/**
* Returns the number (the percentage off) for the current relative discount with monitoring.
* Uses the active promo if available, otherwise falls back to evergreen.
*/
const selectRelativeDiscountWithMonitoring = (state) => (0, exports.selectCurrentPromotionWithMonitoring)(state)
    .chain((0, chain_1.chainProp)('relativeDiscount'));
exports.selectRelativeDiscountWithMonitoring = selectRelativeDiscountWithMonitoring;
/**
* Returns the number for the current absolute discount.
* Uses the active promo if available, otherwise falls back to evergreen.
*/
const selectAbsoluteDiscount = (state) => (0, exports.selectCurrentPromotion)(state)
    .chain((0, chain_1.chainProp)('absoluteDiscount'));
exports.selectAbsoluteDiscount = selectAbsoluteDiscount;
/**
* Returns the number for the current absolute discount with monitoring.
* Uses the active promo if available, otherwise falls back to evergreen.
*/
const selectAbsoluteDiscountWithMonitoring = (state) => (0, exports.selectCurrentPromotionWithMonitoring)(state)
    .chain((0, chain_1.chainProp)('absoluteDiscount'));
exports.selectAbsoluteDiscountWithMonitoring = selectAbsoluteDiscountWithMonitoring;
/**
* Returns the discount text of the promo.
* Uses the active promo if available, otherwise falls back to evergreen.
*/
const selectPromoDiscountText = (state) => {
    const { locale } = state.get('locale');
    return (0, exports.selectCurrentPromotion)(state)
        .chain((0, discounts_1.promoCodeToDiscountDisplayText)(locale));
};
exports.selectPromoDiscountText = selectPromoDiscountText;
/**
* Returns the discount text of the promo with monitoring.
* Uses the active promo if available, otherwise falls back to evergreen.
*/
const selectPromoWithMonitoringDiscountText = (state) => {
    const { locale } = state.get('locale');
    return (0, exports.selectCurrentPromotionWithMonitoring)(state)
        .chain((0, discounts_1.promoCodeToDiscountDisplayText)(locale));
};
exports.selectPromoWithMonitoringDiscountText = selectPromoWithMonitoringDiscountText;
const resolvelDiscountPriceFromPromo = (promoCode, price) => {
    return promoCode
        .chain(promoCode => promoCode.absoluteDiscount)
        .map(discount => price - discount)
        .catchMap(() => promoCode
        .chain(promoCode => promoCode.relativeDiscount)
        .map(discount => price - (price * (discount / 100))));
};
/**
 * Returns a discount price by applying the current promotion applied to a price without a service plan.
 * If there is an active promo it will use those details first, otherwise it uses the evergreen promotion.
 */
const selectCurrentPromoDiscountedPrice = (state) => (price) => {
    const promotion = (0, exports.selectCurrentPromotion)(state);
    return resolvelDiscountPriceFromPromo(promotion, price);
};
exports.selectCurrentPromoDiscountedPrice = selectCurrentPromoDiscountedPrice;
/**
 * Returns a discount price by applying the current promotion applied to a price with a service plan.
 * If there is an active promo it will use those details first, otherwise it uses the evergreen promotion.
 */
const selectCurrentPromoDiscountedPriceWithMonitoring = (state) => (price) => {
    const promotion = (0, exports.selectCurrentPromotionWithMonitoring)(state);
    return resolvelDiscountPriceFromPromo(promotion, price);
};
exports.selectCurrentPromoDiscountedPriceWithMonitoring = selectCurrentPromoDiscountedPriceWithMonitoring;
//# sourceMappingURL=select.js.map